import styled, { css } from 'styled-components';
import { Button } from 'src/components';

export const PageWrapper = styled.div`

  overflow-y: auto;

  background-color: #0E0F10;
  height: 100vh;
  display: grid;
  padding: 30px 30px 30px 60px;

  @media (max-width: 768px) {
    padding: 30px 30px 30px 30px;
  }

  @media (min-width: 1330px) {
    grid-gap: 100px;
    grid-template-columns: 40% auto;
  }

  @media (min-width: 1920px) {
    grid-template-columns: 45% 45%;
  }

`;

export const ContentWrapper = styled.div`
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 1920px) {
    align-items: flex-end;
    width: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;

  margin-left: auto;
  margin-right: auto;

  margin-top: auto;
  margin-bottom: auto;

  border-radius: 5px;
  width: 100%;
  max-width: 487px;

  @media (max-width: 768px) {
    margin-top: 100px;
  }

  .logo {

    img {
      height: 58px;
      margin-bottom: 60px;

      @media (max-width: 768px) {
        height: 60px;
        margin-bottom: 40px;
      }
    }
  }

  .form {
    width: 100%;
  }

  h1 {
    color: #FFFFFF;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  h3 {
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    font-style: normal;
    line-height: normal;
    margin-bottom: 48px;
  }

  .action {
    width: 100%;
    margin-top: 32px;

    button {
      cursor: pointer;
      height: 64px;
      width: 100%;
      border: 0;
      background-color: #00c6c9;
      border-radius: 4px;
      color: #202428;
      font-size: 18px;
      text-transform: capitalize;
      font-weight: 700;
      line-height: normal;
      
      &:hover {
        background-color: #0DA8A4;
      }

      &:active {
        background-color: #16E0DA;
      }
    }

  }

  a {
    color: #FFFFFF;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-decoration-line: underline;
  }

  @media (min-width: 1920px) {
      align-self: flex-end;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-height: 100vh;


  img {
    min-height: 100%;
    max-height: 90vh;
    width: 100%;
    max-width: 100%;
    object-fit: cover;
    border-radius: 24px;
  }

  @media (max-width: 1334px) {
    display: none;
  }
`;

export const InputField = styled.div`
  width: 100%;
  margin-bottom: 16px;

  input {
    width: 100%;
    padding: 20px;
    border-radius: 4px;
    border: 0;
    height: 50px;

    color: #202428 !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;

    border-radius: 4px;
    border: 1px solid #DFDFDF;

    &::placeholder {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
      color: #6B7986 !important;
    }

    &.errorInput {
      border: solid 1px #EB5757;
    }
  }

  .errorMessage {
    color: #EB5757;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 0;
    margin-top: 4px;
  }

`;

export const IconWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
`

export const IconBtn = styled.div`
  svg path {
    stroke: #495F6E;
  }

  svg.eyeIcon {
    position: absolute;
    right: 17px;
    top: calc(50% - 7px);
    width: 20px;
    height: 14px;
  }
`

export const Footer = styled.footer`

  margin-top: 24px;       
  padding-bottom: 16px;

  margin-left: auto;
  margin-right: auto;

  .copyright {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 17px;

    span {
      font-size: 1.4rem;
      color: #FFF;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  @media (min-width: 1920px) {
    width: 100%;
    max-width: 487px;
  }
`;

export const CheckboxButton = styled(Button)`
  cursor: pointer;

  ${({ disabled }) => disabled ? css`
    pointer-events: none;
  ` : ''}

  padding: 5px 0px;
  height: 20px;
  width: 20px;
  margin-right: 2px;
  background-color: transparent;

  &:hover {
    background-color: transparent;
    color: transparent;
  }

  ${(props) => ({
    display: props.isBolded ? "none" : "",
  })}
`;

export const ValidationWrapper = styled.div`
  background-color: #F2FCFC;
  border-radius: 4px;
  margin-top: 4px;
  padding: 16px;

  h4 {
    color: #6B7986;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 8px;
  }
`;

export const ValidationContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 4px;

  p {
    display: flex;
    align-items: center;
    gap: 8px;

    color: #6B7986;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
